/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { FilesControllerGetNutrientConfigQueryResponse, FilesControllerGetNutrientConfigPathParams, FilesControllerGetNutrientConfig400, FilesControllerGetNutrientConfig401, FilesControllerGetNutrientConfig403, FilesControllerGetNutrientConfig404 } from "../../models/filesController/FilesControllerGetNutrientConfig";

function getFilesControllerGetNutrientConfigUrl(id: FilesControllerGetNutrientConfigPathParams["id"]) {
  const res = { method: 'GET', url: `/api/v1/files/${id}/nutrient-config` as const }  
  return res
}

/**
 * @description Returns all data required to render a file via Nutrient, including JWT token, prerender status, fileUuid, and serverUrl.
 * @summary Get Nutrient viewer configuration for a file
 * {@link /api/v1/files/:id/nutrient-config}
 */
export async function filesControllerGetNutrientConfig(id: FilesControllerGetNutrientConfigPathParams["id"], config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const res = await request<FilesControllerGetNutrientConfigQueryResponse, ResponseErrorConfig<FilesControllerGetNutrientConfig400 | FilesControllerGetNutrientConfig401 | FilesControllerGetNutrientConfig403 | FilesControllerGetNutrientConfig404>, unknown>({ method : "GET", url : getFilesControllerGetNutrientConfigUrl(id).url.toString(), ... requestConfig })  
  return res.data
}